// Эквид иногда перезаписывает одно и то же значение по несколько раз из-за, видимо,
// кривых хэндлеров разных событий.
// Мы в этом случае повторно записываем готовую сконвертированную ранее цену

// Transition: ecwid bullshit deffered callback
// html price =
// selected target currency
// Data attribute: target currency
// Data attribute: original price =
// Data attribute: converted price
// Просто конвертируем заново. Не меняем аттрибуты
import { setElementState } from '../priceControls';

const matchState = (state) => {
  return (
    state.htmlPrice !== null &&
    state.originalPrice !== null &&
    state.htmlPrice === state.originalPrice &&
    state.convertedCurrency === state.selectedTargetCurrency
  );
};

const handle = (priceElement, state) => {
  setElementState(priceElement, state);
};

export default { matchState, handle, name: 'idle' };
